export enum EngagementState {
    Started = 'Started',
    Ended = 'Ended',
}
